import React from 'react';

const NotFound = () => {
    return (
        <div className="text-center">
            <h3 >Not found</h3>
            <p style={{color: 'red'}}>404 error!!!</p>
        </div>
    );
};

export default NotFound;